import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.xs};
  width: 100%;
  position: relative;
`;

export const Label = styled.label`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.landing.text};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.95rem;
  }
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledInput = styled.input`
  margin-top: ${({ theme }) => theme.landingSpacing.xs};
  width: 100%;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ icon }) => (icon ? '0.9375rem 1rem 0.9375rem 2.75rem' : '0.9375rem 1rem')};
  background: ${({ theme }) => theme.landing.inputBg};
  border: 1px solid ${({ theme }) => theme.landing.inputBorder};
  color: ${({ theme }) => theme.landing.text};
  transition: all 0.3s ease;
  outline: none;
  font-size: 1rem;
  line-height: 1.5;

  &::placeholder {
    color: ${({ theme }) => theme.landing.textMuted};
  }

  &:focus {
    border-color: ${({ theme }) => theme.landing.buttonBg};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.landing.buttonBg}33;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 0.95rem;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  left: 16px;
  top: 58%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  svg {
    width: ${({ iconSize }) => iconSize || '16px'};
    height: ${({ iconSize }) => iconSize || '16px'};
    fill: ${({ theme }) => theme.landing.textMuted};
  }
`;
